customElements.define('read-more', class ReadMore extends HTMLElement {
  constructor() {
    super();

    this.collapsedContent = this.querySelector('[data-collapsed-content]');
    this.toggleBtn = this.querySelector('[data-toggle-btn]');

    this.toggleBtn.addEventListener('click', () => {
      this.collapsedContent.classList.remove('hidden');
      this.toggleBtn.remove();
      this.sendReadMoreGTMData();
    });

    if (window.innerWidth < 768) {
      this.querySelectorAll('.js-seo-column').forEach((column, index) => {
        if (index !== 0) {
          column.open = false;
        }
      });
    }
  }
  sendReadMoreGTMData() {
    window.sendGTMData && window.sendGTMData({
      event: 'plp_read_more'
    });
  }
});
